import { getCookie } from "../cookies"
import { setCookie } from "../cookies"
import { removeCookie } from "../cookies"

// Set cookie path so we don't get duplicates
const cookiePath = { path: "/" };

// Set max allowed selections
const maxAllowed = 2;

let monthsArr = [],
    selectedMonthsArr = [],
    monthsCount = 0,
    interestFreeMonths = document.querySelectorAll("input[name=termfreemonth]"),
    isCheckedItems = document.querySelectorAll("label.is-checked");

// If interestFree cookie is set
let interestFreeCookie = getCookie('interestFree'),
    formattedValue = interestFreeCookie.split(',').join(' - ');

for (let i = 0; i < interestFreeMonths.length; i++) {
    // Create array to filter with current cookie values
    selectedMonthsArr.push(interestFreeMonths[i].value);

    // Check if cookie is present and set selected months
    interestFreeMonths[i].addEventListener('change', function () {

        const parent = this.parentElement;
        let isChecked = parent.classList.contains('is-checked');
        monthsCount = monthsArr.length;

        if (monthsCount < maxAllowed && !isChecked) {
            parent.classList.add("is-checked");
            //Add to array 'monthsArr'
            monthsArr.push(this.value)
            checkedItems()
            // Set Cookie with array values
            removeCookie("interestFree");
            setCookie("interestFree", JSON.stringify(monthsArr), cookiePath)
            sethtml()
        }
        else if (monthsCount <= maxAllowed && isChecked) {
            parent.classList.remove('is-checked');
            checkedItems()
            //Remove from array 'monthsArr'
            let deleteValue = monthsArr.indexOf(this.value);
            if (deleteValue > -1) {
                monthsArr.splice(deleteValue, 1)
            }

            setCookie("interestFree", JSON.stringify(monthsArr), cookiePath)
            sethtml()
        }
    })
}

//Get Current number of checked months
function populate() {

    if (interestFreeCookie.length) {
        const currentCookieVal = JSON.parse(interestFreeCookie);
        const chosenMonthsVal = selectedMonthsArr;

        monthsArr = currentCookieVal;
        let filteredVal = currentCookieVal.filter((word) => chosenMonthsVal.includes(word));

        for (let i = 0; i < isCheckedItems.length; i++) {
            isCheckedItems[i].classList.remove('is-checked')
        }
        for (let f = 0; f < interestFreeMonths.length; f++) {
            let monthsToPopulate = interestFreeMonths[f];
            for (let i = 0; i < filteredVal.length; i++) {
                let cookieVal = filteredVal[i];
                let parent = monthsToPopulate.parentElement;
                //parent.classList.remove('is-checked')

                if (monthsToPopulate.value == cookieVal) {
                    let parent = monthsToPopulate.parentElement;
                    parent.classList.add("is-checked");
                }
            }
        }
        checkedItems()
    }
}

function checkedItems() {
    let isCheckedItems = document.querySelectorAll("label.is-checked");
    monthsCount = 0;

    for (let i = 0; i < isCheckedItems.length; i++) {
        monthsCount++
    }
}

function sethtml() {

    let interestFreeCookie = getCookie('interestFree');
    if (interestFreeCookie.length) {
        let parsedCookieVal = JSON.parse(interestFreeCookie);
        parsedCookieVal = parsedCookieVal.toString().replace(",", " - ");

        let setInterestFreeHTML = document.querySelector('.calc-loan-yearly-interest-free-months');

        if (setInterestFreeHTML) {
            setInterestFreeHTML.innerHTML = parsedCookieVal;
        }
    }

}

populate()
sethtml()



